import { ShippingOrder } from "@/interfaces/shipping-order";

const initialState = () => ({
  shippingOrder: null,
});

const state: any = initialState();

const mutations = {
  reset(state: any) {
    const newState: any = initialState();
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },
  setShippingOrder(state: any, payload: ShippingOrder) {
    state.shippingOrder = payload;
  },
};

const getters = {
  getShippingOrder: (state: any) => state.shippingOrder,
};

const actions = {
  reset({ commit }: any) {
    commit("reset");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
